import { all } from 'typed-redux-saga'
import {
	actsLogsSaga,
	bgEventsAstLogsSaga,
	bgEventsLogsSaga,
	bgEventsRequestStatusLogsSaga,
	customerIdentificationLogsSaga,
	knowledgeLogsSaga,
	newOrdersLogsSaga,
	onlineOrdersLogsSaga,
	apiRequestsLogsSaga,
	ordersApiLogsSaga,
	ordersLogsSaga,
	partnerLogsSaga,
	qaRequestsLogsSaga,
	rbidosRequestsLogsSaga,
	reportsLogsSaga,
	reserveAccountsLogsSaga,
	sberCrmLogsSaga,
	smsRuleLogsSaga,
	statusesLogsSaga,
	usersLogsSaga,
	changeStatusErrorsLogsSaga,
	integrationChannelLogsSaga,
	externalRequestsLogsSaga,
	departmentLogsSaga,
	preRecordSaga,
	bprofileLogsSaga,
	blankRegistrationDateLogsSaga,
	svetoforLogsSaga,
} from 'Pages/logs'

export function* logsSaga() {
	yield* all([
		actsLogsSaga(),
		bgEventsLogsSaga(),
		bgEventsRequestStatusLogsSaga(),
		changeStatusErrorsLogsSaga(),
		apiRequestsLogsSaga(),
		customerIdentificationLogsSaga(),
		knowledgeLogsSaga(),
		newOrdersLogsSaga(),
		onlineOrdersLogsSaga(),
		ordersLogsSaga(),
		partnerLogsSaga(),
		rbidosRequestsLogsSaga(),
		reportsLogsSaga(),
		reserveAccountsLogsSaga(),
		sberCrmLogsSaga(),
		smsRuleLogsSaga(),
		statusesLogsSaga(),
		usersLogsSaga(),
		ordersApiLogsSaga(),
		bgEventsAstLogsSaga(),
		qaRequestsLogsSaga(),
		integrationChannelLogsSaga(),
		externalRequestsLogsSaga(),
		departmentLogsSaga(),
		preRecordSaga(),
		bprofileLogsSaga(),
		blankRegistrationDateLogsSaga(),
		svetoforLogsSaga(),
	])
}
